<% if ( pack ) { %>
<div class="card">
    <div class="card-body">
        <div class="d-flex align-items-center justify-content-between mb-4">
            <div>
                <h4 class="card-title mb-0"><%= pack.name %></h4>
            </div>
            <div class="d-flex gap-2">
                <% if ( pack.status === 'ACTIVE' ) { %>
                <button type="button"
                        data-type="pack-toggle-status"
                        class="btn btn-outline-warning">
                    <i class="ti ti-player-pause me-1"></i>Deactivate
                </button>
                <% } else { %>
                <button type="button"
                        data-type="pack-toggle-status"
                        class="btn btn-outline-success">
                    <i class="ti ti-player-play me-1"></i>Activate
                </button>
                <% } %>
                <button type="button"
                        data-type="pack-edit-button"
                        class="btn btn-primary">
                    <i class="ti ti-pencil me-1"></i>Edit
                </button>
                <button type="button"
                        data-type="pack-delete-button"
                        class="btn btn-danger">
                    <i class="ti ti-trash me-1"></i>Delete
                </button>
            </div>
        </div>

        <ul class="nav nav-pills user-profile-tab border-bottom" id="packTabs" role="tablist">
            <li class="nav-item" role="presentation">
                <button class="nav-link position-relative rounded-0 active d-flex align-items-center justify-content-center bg-transparent fs-3 py-3"
                        data-type="pack-tab" data-tab-target="#pills-detail"
                        type="button" role="tab" aria-controls="pills-detail" aria-selected="true">
                    <i class="ti ti-info-circle me-2 fs-6"></i>
                    <span class="d-none d-md-block">Detail</span>
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link position-relative rounded-0 d-flex align-items-center justify-content-center bg-transparent fs-3 py-3"
                        data-type="pack-tab" data-tab-target="#pills-testcenter"
                        type="button" role="tab" aria-controls="pills-testcenter" aria-selected="false">
                    <i class="ti ti-test-pipe me-2 fs-6"></i>
                    <span class="d-none d-md-block">Test Center</span>
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link position-relative rounded-0 d-flex align-items-center justify-content-center bg-transparent fs-3 py-3"
                        data-type="pack-tab" data-tab-target="#pills-generated-documents"
                        type="button" role="tab" aria-controls="pills-generated-documents" aria-selected="false">
                    <i class="ti ti-files me-2 fs-6"></i>
                    <span class="d-none d-md-block">Generated Documents</span>
                </button>
            </li>
        </ul>

        <div class="tab-content pt-4" id="packTabContent">
            <div class="tab-pane fade show active" id="pills-detail" role="tabpanel" aria-labelledby="pills-detail-tab" tabindex="0">
                <div class="row">
                        <div class="col-md-12">
                            <div class="mb-3">
                                <label class="form-label text-muted text-uppercase fw-bold detail-label">Description</label>
                                <p class="mb-0 fs-4"><%= pack.description ? pack.description : 'No description provided' %></p>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label text-muted text-uppercase fw-bold detail-label">Pack ID</label>
                                <p class="mb-0 fs-4 fw-medium"><pre><%= pack.id %></pre></p>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label text-muted text-uppercase fw-bold detail-label">Status</label>
                                <p class="mb-0 fs-4">
                                    <% if ( pack.status === 'ACTIVE' ) { %>
                                        <span class="badge bg-success-subtle text-success">Active</span>
                                    <% } else { %>
                                        <span class="badge bg-warning-subtle text-warning">Inactive</span>
                                    <% } %>
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label text-muted text-uppercase fw-bold detail-label">Created At</label>
                                <p class="mb-0 fs-4 fw-medium"><%= pack.createdAt ? new Date(pack.createdAt).toLocaleString() : '---' %></p>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label text-muted text-uppercase fw-bold detail-label">Updated At</label>
                                <p class="mb-0 fs-4 fw-medium"><%= pack.updatedAt ? new Date(pack.updatedAt).toLocaleString() : '---' %></p>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="mb-3">
                                <label class="form-label text-muted text-uppercase fw-bold detail-label">Templates</label>
                                <p class="mb-0 fs-4 fw-medium"><%= templates.length %> template(s) in this pack</p>
                            </div>
                        </div>
                </div>

                <% templates.forEach(( tmpl, tmplIndex ) => { %>
                <div class="border-top pt-4 mt-4">
                    <h5 class="mb-3" data-type="placeholders-toggle" data-template-index="<%= tmplIndex %>" style="cursor: pointer;">
                        <i class="ti ti-chevron-right me-1" data-type="placeholders-toggle-icon" data-template-index="<%= tmplIndex %>"></i>
                        <i class="ti ti-file-text me-1 text-primary"></i>
                        <%= tmpl.name %>
                        <% const placeholders = tmpl.data && tmpl.data.placeholders ? tmpl.data.placeholders : {}; %>
                        <% const placeholderKeys = Object.keys(placeholders); %>
                        <span class="badge bg-primary-subtle text-primary ms-2"><%= placeholderKeys.length %> placeholder(s)</span>
                    </h5>
                    <div data-type="placeholders-content" data-template-index="<%= tmplIndex %>" style="display: none;">
                        <% if (placeholderKeys.length > 0) { %>
                            <div class="table-responsive">
                                <table class="table table-hover table-sm" style="table-layout: fixed;">
                                    <thead style="background: transparent;">
                                        <tr>
                                            <th class="text-muted text-uppercase fw-bold detail-label" style="width: 25%;">Key</th>
                                            <th class="text-muted text-uppercase fw-bold detail-label" style="width: 60%;">Description</th>
                                            <th class="text-muted text-uppercase fw-bold detail-label" style="width: 15%;">Type</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <% placeholderKeys.forEach((key) => { %>
                                            <% const placeholder = placeholders[key]; %>
                                            <tr>
                                                <td><code><%= placeholder.key || key %></code></td>
                                                <td class="placeholder-description-cell"
                                                    data-type="placeholder-description"
                                                    data-template-id="<%= tmpl.id %>"
                                                    data-placeholder-key="<%= placeholder.key || key %>"
                                                    style="color: var(--bs-card-color); cursor: pointer; position: relative;"
                                                    title="Click to edit">
                                                    <span class="description-text"><%= placeholder.description || '' %></span>
                                                    <span class="description-placeholder text-muted"><%= placeholder.description ? '' : 'Click to add description...' %></span>
                                                    <i class="ti ti-pencil ms-2 text-muted description-edit-icon" style="font-size: 0.85em; opacity: 0; transition: opacity 0.2s;"></i>
                                                </td>
                                                <td><span class="badge bg-secondary"><%= placeholder.type || '---' %></span></td>
                                            </tr>
                                        <% }); %>
                                    </tbody>
                                </table>
                            </div>
                        <% } else { %>
                            <p class="text-muted">No placeholders defined for this template.</p>
                        <% } %>
                    </div>
                </div>
                <% }); %>

            </div>

            <div class="tab-pane fade" id="pills-testcenter" role="tabpanel" aria-labelledby="pills-testcenter-tab" tabindex="0">
                <% if ( templates.length > 0 ) { %>
                    <% templates.forEach(( tmpl, tmplIndex ) => { %>
                    <div class="mb-4">
                        <h5 class="mb-3 d-flex align-items-center">
                            <i class="ti ti-file-text me-2 text-primary"></i>
                            <%= tmpl.name %>
                        </h5>
                        <test-center data-template-index="<%= tmplIndex %>"></test-center>
                    </div>
                    <% if ( tmplIndex < templates.length - 1 ) { %>
                    <hr class="my-4" />
                    <% } %>
                    <% }); %>

                    <hr class="my-4" />
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="text-muted small">
                            <i class="ti ti-info-circle me-1"></i>
                            Fill in the values for each template above and click "Run Pack Generation" to generate a merged document.
                        </div>
                        <div class="d-flex gap-2">
                            <button type="button" data-type="pack-show-code" class="btn btn-outline-secondary">
                                <i class="ti ti-code me-2"></i>Example Code
                            </button>
                            <button type="button" data-type="pack-run-test" class="btn btn-primary">
                                <i class="ti ti-player-play me-2"></i>Run Pack Generation
                            </button>
                        </div>
                    </div>
                <% } else { %>
                    <div class="text-center py-5">
                        <i class="ti ti-file-off display-4 text-muted mb-3"></i>
                        <h5 class="text-muted">No Templates</h5>
                        <p class="text-muted mb-0">This pack has no templates assigned.</p>
                    </div>
                <% } %>
            </div>

            <div class="tab-pane fade" id="pills-generated-documents" role="tabpanel" aria-labelledby="pills-generated-documents-tab" tabindex="0">
                <div id="generated-documents-table"></div>
            </div>
        </div>

        <div class="border-top pt-4 mt-4">
            <a href="/pack/list" class="btn btn-outline-secondary">
                <i class="ti ti-arrow-left me-2"></i>Back to Packs
            </a>
        </div>
    </div>
</div>

<style>
/* Hide per-template action bar (hr + buttons) from test-center components in pack context */
#pills-testcenter test-center > hr.my-4 {
    display: none !important;
}
#pills-testcenter test-center > .d-flex.justify-content-between {
    display: none !important;
}
.placeholder-description-cell:hover .description-edit-icon {
    opacity: 1 !important;
}
.placeholder-description-cell:hover {
    background-color: var(--bs-tertiary-bg);
}
.placeholder-description-cell .description-input {
    border: 1px solid var(--bs-primary);
    border-radius: 4px;
    padding: 4px 8px;
    width: 100%;
    font-size: inherit;
    background: var(--bs-body-bg);
    color: var(--bs-body-color);
}
.placeholder-description-cell .description-input:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(var(--bs-primary-rgb), 0.25);
}
.placeholder-description-cell.saving {
    opacity: 0.6;
    pointer-events: none;
}
</style>
<% } else { %>
<div class="card">
    <div class="card-body text-center py-5">
        <i class="ti ti-package display-4 text-muted mb-3"></i>
        <h4 class="text-muted">Pack Not Found</h4>
        <p class="text-muted mb-4">The pack you're looking for doesn't exist or has been deleted.</p>
        <a href="/pack/list" class="btn btn-primary">
            <i class="ti ti-arrow-left me-2"></i>Back to Packs
        </a>
    </div>
</div>
<% } %>
